import Vue from 'vue'
/**
 * 自动检测 action 的loading状态
 */
const IGNORE_NS = ['TagManage']
const IGNORE_TAG = '$$'

export function afterStoreCreate(_, { registerStore }) {
  // vuex >= 2.5.0
  const namespace = 'loading'
  const loadingStart = '$$Start'
  const loadingEnd = '$$End'
  const startLoading = `${namespace}/${loadingStart}`
  const endLoading = `${namespace}/${loadingEnd}`
  registerStore({
    namespace,
    state: {},
    mutations: {
      [loadingStart]: (state, payload) => Vue.set(state, payload, true),
      [loadingEnd]: (state, payload) => Vue.set(state, payload, false)
    },
    subscribeAction: {
      before: ({ commit }, { type }) => allowLog(type),
      after: ({ commit }, { type }) => allowLog(type)
    }
  })
}

function allowLog(type) {
  return !type.includes(IGNORE_TAG) && IGNORE_NS.every(ns => !type.startsWith(ns))
}
